import { defineMessages } from "react-intl";

export const giftCardCustomerCardMessages = defineMessages({
  customerGiftCardsPresentSubtitle: {
    id: "vzce9B",
    defaultMessage: "Only five newest gift cards are shown here",
    description: "customer gift cards card subtitle",
  },
  customerGiftCardsAbsentSubtitle: {
    id: "vWTM6Y",
    defaultMessage: "There are no gift cards assigned to this customer",
    description: "customer gift cards card no cards subtitle",
  },
  customerGiftCardsViewAllButton: {
    id: "FQc5z6",
    defaultMessage: "View All",
    description: "customer gift cards card view all button",
  },
  customerGiftCardsIssueNewCardButton: {
    id: "mbOuGl",
    defaultMessage: "Issue new card",
    description: "customer gift cards card issue button",
  },
  customerGiftCardsCardTitle: {
    id: "Utq1fE",
    defaultMessage: "Gift Cards",
    description: "customer gift cards card title",
  },
});
